module.exports = __webpack_public_path__ + "img/independent-reader.cea7dcb5.png";